export default __webpack_public_path__ + "maps-overivew-annotation-image-1200-0a210aa774050333b53c3d502ee01df0.png";